import { FC } from "react";

const Icon: FC<{ type?: "success" | "error" }> = ({ type = "" }) => {
  switch (type) {
    case "success":
      return (
        <svg
          width="88"
          height="88"
          viewBox="0 0 88 88"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="44"
            cy="44"
            r="43.75"
            fill="#F0FAF5"
            stroke="#42BE77"
            strokeWidth="0.5"
          />
          <path
            d="M54.4498 38.5L40.5164 51.7L33.5498 45.1"
            stroke="#42BE77"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "error":
      return (
        <svg
          width="88"
          height="88"
          viewBox="0 0 88 88"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="44"
            cy="44"
            r="43.75"
            fill="#FFF4F2"
            stroke="#F64629"
            strokeWidth="0.5"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M51.7048 38.7069C52.0953 38.3163 52.0951 37.6832 51.7045 37.2927C51.3139 36.9023 50.6807 36.9024 50.2903 37.2931L43.9989 43.5873L37.7076 37.2931C37.3171 36.9024 36.684 36.9023 36.2934 37.2927C35.9027 37.6832 35.9026 38.3163 36.293 38.7069L42.585 45.0019L36.2927 51.2971C35.9023 51.6877 35.9024 52.3209 36.2931 52.7113C36.6837 53.1018 37.3168 53.1016 37.7073 52.711L43.9989 46.4164L50.2906 52.711C50.681 53.1016 51.3142 53.1018 51.7048 52.7113C52.0954 52.3209 52.0956 51.6877 51.7051 51.2971L45.4128 45.0019L51.7048 38.7069Z"
            fill="#F64629"
          />
        </svg>
      );

    default:
      return null;
  }
};

export default Icon;
